
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";
import axios from "axios";
export const fetchMedias = createAsyncThunk("medias/fetchMedias", async () => {
  const response = await apiCustom.get("/get-media");
  return response.data?.data?.images;
});
export const fetchVideos = createAsyncThunk("medias/fetchVideos", async () => {
  const response = await apiCustom.get("/get-media-video");
  return response.data?.data?.images;
});

export const fetchPublicVideos = createAsyncThunk(
  "medias/fetchPublicVideos",
  async () => {
    const response = await apiCustom.get("/get-media-video-public");
    return response.data?.data?.images;
  }
);
export const createMedia = createAsyncThunk(
  "medias/createMedia",
  async (newPost, { rejectWithValue }) => {
    try {
      const response = await apiCustom.post("/upload-media", newPost);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const createMultiImage = createAsyncThunk(
  "medias/createMultiImage",
  async (newPost, { rejectWithValue }) => {
    try {
      const response = await apiCustom.post("/upload-multi-image", newPost);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const createMediaH = createAsyncThunk(
  "medias/createMedia",
  async (newPost, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "https://vdhuytest.s3.ap-southeast-1.wasabisys.com/my-image.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=A9AIDACTA68N25P6IV1V%2F20250224%2Fap-southeast-1%2Fs3%2Faws4_request&X-Amz-Date=20250224T073508Z&X-Amz-Expires=1800&X-Amz-Signature=4fb6662d2ebf1cb7940e74488ce2985cccb413be3aa4d794ff2012c4081f55d6&X-Amz-SignedHeaders=host&x-amz-checksum-crc32=AAAAAA%3D%3D&x-amz-sdk-checksum-algorithm=CRC32&x-id=PutObject",
        newPost
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const updateMedia = createAsyncThunk(
  "medias/updateMedia",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(`/update-media/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const deleteMedia = createAsyncThunk(
  "medias/deleteMedia",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.delete(`/delete-media/${id}`);
      return { response };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

const mediaSlice = createSlice({
  name: "medias",
  initialState: {
    medias: [],
    status: "idle",
    error: null,
    publicMedias: [],
    publicStatus: "idle",
    publicError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMedias.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchMedias.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.medias = action.payload;
      })
      .addCase(fetchVideos.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.medias = action.payload;
      })
      .addCase(fetchPublicVideos.fulfilled, (state, action) => {
        state.publicStatus = "succeeded";
        state.publicMedias = action.payload;
      })
      .addCase(createMedia.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(createMultiImage.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(updateMedia.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(deleteMedia.fulfilled, (state) => {
        state.status = "idle";
      });
  },
});

export default mediaSlice.reducer;


